module.exports = __webpack_public_path__ + "img/thumbnail_Aardvark_j_albino.267b4838.png";